module.exports = __webpack_public_path__ + "Hash.png";